export default "__VITE_ASSET__DZMdfllW__"